import React from 'react';
import { connect } from 'react-redux';
import AccountInfo from './AccountInfo';
import Notification from './alerts/notification/Notification';
import Language from './Language';
import LoginButton from './LoginButton';
import Logout from './Logout';
import Theme from './Theme';
import './index.scss';
import AlertSubscriber from './alerts/AlertSubscriber';
import Time from './Time';

const Right = ({ user }) => {
  const isLoggedIn = !!Object.keys(user).length;

  return (
    <div className="main-layout-top-right-wrap">
      <div className="top-right float-right timer-top">
        <Time />
        {isLoggedIn && <AccountInfo />}
        {isLoggedIn && <Notification />}
        <AlertSubscriber />
        <Language />
        {isLoggedIn && <Logout />}
        {!isLoggedIn && <LoginButton />}
      </div>
      <Theme />
    </div>
  );
};

const mapStateToProps = state => ({
  user: state.userInfo,
});

export default connect(mapStateToProps)(Right);
